import type { Item, Option } from "@/types"

/**
 * Single source of truth for "can this option be picked right now?".
 *
 * An option carries TWO availability signals and either one can take it off the
 * shelf:
 *   1. `Option.status`, the status of this option's placement inside the group;
 *   2. the status of the `Item` it points at, which is where the merchant's
 *      "Em falta" toggle lands for pizza flavors (the portal patches the ITEM,
 *      not the placement).
 *
 * Reading only the first one is what let a paused flavor stay orderable on the
 * storefront. Both default to available when the payload omits them.
 */
export function isOptionAvailable(
  option: Pick<Option, "status"> | undefined,
  item: Pick<Item, "status"> | undefined,
): boolean {
  if (option?.status === "UNAVAILABLE") return false
  if (item?.status === "UNAVAILABLE") return false
  return true
}
